<template>
  <ui-dialog show max-width="968px" @input="closeDialog">
    <template #header>
      <h3>{{ $t("message.facebook.selectPageDialog.title") }}</h3>
    </template>
    <div class="content">
      <SectionLoader v-if="isLoading" :status="isLoading" :opacity="1" />

      <div>
        <p v-html="$t('message.facebook.selectPageDialog.description')"></p>
        <InfoBox
          class="mt-2"
          :text="$t('message.facebook.selectPageDialog.infobox')"
        />
      </div>
      <div>
        <div class="page-list">
          <v-list rounded max-height="300px" class="overflow-y-auto">
            <v-list-item-group v-model="pagesIds" multiple>
              <v-list-item
                v-for="page in pages"
                :key="page.id"
                :ripple="false"
                :value="page.id"
                :disabled="page.is_integration_enabled"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title
                      ><FbIcon />{{ page.name }}</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-checkbox
                      :disabled="page.is_integration_enabled"
                      :input-value="page.is_integration_enabled || active"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </div>
    </div>
    <div class="actions">
      <ui-button color="primary" outlined @click="closeDialog">
        {{ $t("message.common.cancel") }}
      </ui-button>
      <ui-button color="primary" @click="confirmIntegrationHandler">
        {{ $t("message.facebook.selectPageDialog.confirmAndStartIntegration") }}
      </ui-button>
    </div>
  </ui-dialog>
</template>

<script>
import InfoBox from "@/components/ui/InfoBox.vue";
import FbIcon from "../ui/Icons/FbIcon.vue";
import facebookService from "@/services/facebook";
import SectionLoader from "@/components/Loader/SectionLoader.vue";

export default {
  name: "PageSelectDialog",
  components: {
    InfoBox,
    FbIcon,
    SectionLoader
  },
  props: {
    pages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      pagesIds: [],
      isLoading: false
    };
  },
  methods: {
    async confirmIntegrationHandler() {
      this.isLoading = true;
      await facebookService.enablePages(this.pagesIds);
      this.isLoading = false;
      this.$emit("show-integration-confirm-dialog");
      this.$emit("close");
    },
    closeDialog() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.actions {
  padding: $spacing * 4 0 $spacing * 3.5 0;
  display: flex;
  justify-content: flex-end;
  gap: $spacing * 4;
}

.content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: $spacing * 4;
  color: $dark-blue-2;
}
.page-list {
  border-radius: 24px;
  border: 1px solid $gray-600;
  overflow: hidden;

  ::v-deep .v-list--rounded .v-list-item,
  .v-list--rounded .v-list-item::before,
  .v-list--rounded .v-list-item > span.v-ripple__container {
    border-radius: 16px !important;
    padding-top: $spacing;
    padding-bottom: $spacing;
  }

  ::v-deep .v-item--active:before {
    opacity: 0;
  }

  ::v-deep .v-item--active {
    background: $gray-600;
  }

  ::v-deep .v-list-item__title {
    display: flex;
    align-items: center;
    gap: $spacing * 1.5;
  }

  ::v-deep .v-list--rounded .v-list-item:not(:last-child) {
    border-bottom: 1px solid $gray-600;
  }
}
</style>
